import React, { useState, useEffect } from "react";
import "./ThemeSwitch.css";
import { MoonIcon, SunDimIcon } from "@phosphor-icons/react";

const ThemeSwitch = () => {
  const [theme, setTheme] = useState("light");

  // Set theme in the DOM
  const applyTheme = (selectedTheme) => {
    document.querySelector("body").setAttribute("data-theme", selectedTheme);
    setTheme(selectedTheme);
  };

  const toggleTheme = (e) => {
    if (e.target.checked) {
      applyTheme("dark");
    } else {
      applyTheme("light");
    }
  };

  // Load saved theme from localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    applyTheme(savedTheme);
  }, []);

  // Save theme to localStorage
  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <div className="toggle-switch">
      <label className="switch">
        <input
          type="checkbox"
          checked={theme === "dark"} // Checkbox checked if theme is dark
          onChange={toggleTheme}
        />
        <div className="slider">
          {theme === "dark" ? (
            <div className="radiating-sun">
              <SunDimIcon size={32} weight="regular" className="icon"/>
            </div> // Sun icon for light theme
          ) : (
            <div className="radiating-moon">
              <MoonIcon size={32} weight="regular" className="icon"/>
            </div> // Moon icon for dark theme
          )}
        </div>
      </label>
    </div>
  );
};

export default ThemeSwitch;
